import { QRCodeCanvas } from 'qrcode.react';
import styled, { css } from 'styled-components';

import BottomSheet from '@/components/molecules/BottomSheet';
import { Client } from '@/types/app';

interface Props {
  buttonId?: string;
  treatmentMedicineId?: string;
  title: string;
  description: string;
  qrCodeUrl: string;
  onClose: () => void;
  onClickOpenAppInstallLink: () => void;
  client: Client;
}
const DiagnosisAppInstallBottomSheet = ({
  buttonId,
  onClose,
  title,
  treatmentMedicineId = '0',
  description,
  qrCodeUrl,
  onClickOpenAppInstallLink,
  client,
}: Props) => {
  return (
    <BottomSheet isOpened={true} onClickOverlay={onClose} index={500}>
      {client.isMobile ? (
        <Wrapper>
          <Title>{title}</Title>
          <ImageWrapper>
            <ReceiptImage
              src={'/images/nonBenefit/image_mobile_seo.png'}
              alt="계산서 이미지"
            />
          </ImageWrapper>
          <SubmitButton
            id={
              buttonId ? buttonId : `selected-medicine-${treatmentMedicineId}`
            }
            onClick={onClickOpenAppInstallLink}
          >
            앱에서 최저가 확인하기
          </SubmitButton>
        </Wrapper>
      ) : (
        <Wrapper>
          <Title>{title}</Title>
          <QRCodeWrapper>
            <QRCodeCanvas value={qrCodeUrl} size={120} />
          </QRCodeWrapper>
          <Description>{description}</Description>
        </Wrapper>
      )}
    </BottomSheet>
  );
};

export default DiagnosisAppInstallBottomSheet;

const Wrapper = styled.div`
  padding: 24px 20px 32px;
`;

const Title = styled.p`
  ${({ theme }) => theme.typography.UI22SB}
  color: ${({ theme }) => theme.color.gray900};
  padding: 0 4px;
  white-space: pre-line;
  margin-bottom: 20px;
  word-break: keep-all;
`;

const Description = styled.p`
  ${({ theme }) => theme.typography.UI15R}
  color: ${({ theme }) => theme.color.gray600};
  margin-bottom: 24px;
  text-align: center;
`;

const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  margin-bottom: 8px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ReceiptImage = styled.img`
  height: 141px;
  object-fit: cover;
`;

const SubmitButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  border-radius: 12px;
  margin-top: 40px;
  ${({ theme }) => css`
    ${theme.typography.UI17SB}
    color: ${theme.color.white};
    background-color: ${theme.color.primary600};
  `}
`;
